import { getMapConfig } from '@apis/map';
import DataHookFactory from '@templates/DataHookFactory';
import safeExecute from '@utils/safeExecute';
import axios from 'axios';

const useCampingMapData = DataHookFactory(
  async () => {
    const resp = await getMapConfig();
    if (resp.status !== 200) throw new Error('Get map config failed');
    const mapData = await axios.get(resp.data.mapSrc);
    if (mapData.status !== 200) throw new Error('Get map config failed');
    return {
      svgData: mapData.data,
      mappingData: await safeExecute(
        () =>
          typeof resp.data.mappingData === 'string'
            ? JSON.parse(resp.data.mappingData)
            : resp.data.mappingData,
        {},
      ),
    };
  },
  {
    minimumInterval: 5000,
    autoFetch: true,
  },
);

export default useCampingMapData;
